export default __webpack_public_path__ + "static/media/work0.2814f6d5.png";